import { IFonts } from 'styled-components';

export class Fonts implements IFonts {
  bold = 'font-weight: bold;';
  normalWeight = 'font-weight: normal;';
  mediumWeight = 'font-weight: normal; font-weight: 500;';
  semiBoldWeight = 'font-weight: normal; font-weight: 800;';
  defaultFamily = 'font-family: Open Sans, sans-serif;';
  header1LineHeight = 'line-height: 40px;';
  header2LineHeightValue = 36;
  header2LineHeight = `line-height: ${this.header2LineHeightValue}px;`;
  header3LineHeight = 'line-height: 32px;';
  header4LineHeight = 'line-height: 24px;';
  header5LineHeight = 'line-height: 20px;';
  bodyLineHeight = 'line-height: 24px;';
  smallLineHeight = 'line-height: 20px;';
  tinyLineHeight = 'line-height: 16px;';
  eyebrowLineHeight = this.tinyLineHeight;
  normalButtonLineHeight = 'line-height: 24px;';
  smallButtonLineHeight = 'line-height: 20px;';
  header1Size = 'font-size: 35px;';
  header2SizeValue = 29;
  header2SizeUnit = 'px';
  header2Size = `font-size: ${this.header2SizeValue}${this.header2SizeUnit};`;
  header3Size = 'font-size: 24px;';
  header4Size = 'font-size: 20px;';
  header5Size = 'font-size: 16px;';
  bodySize = 'font-size: 14px;';
  smallSize = 'font-size: 14px;';
  tinySize = 'font-size: 12px;';
  eyebrowSize = 'font-size: 11px;';
  normalButtonSize = this.tinySize;
  smallButtonSize = this.smallSize;
  standardLetterSpacing = '0.1px';
  defaultTextTransform = 'text-transform: none;';
  eyebrowTextTransform = 'text-transform: uppercase;';
  defaultLetterSpacing = 'letter-spacing: normal;';
  eyebrowLetterSpacing = 'letter-spacing: 0.3px;';
  header1LetterSpacing = `letter-spacing: ${this.standardLetterSpacing};`;
  header2LetterSpacing = `letter-spacing: ${this.standardLetterSpacing};`;
  header3LetterSpacing = `letter-spacing: ${this.standardLetterSpacing};`;
  header4LetterSpacing = `letter-spacing: ${this.standardLetterSpacing};`;
  header5LetterSpacing = `letter-spacing: ${this.standardLetterSpacing};`;
  mixins = {
    //TODO: flatten fonts so mixins is gone and elements are at same level as everything else
    header1: `${this.defaultFamily}${this.header1Size}${this.header1LineHeight}${this.mediumWeight}${this.header1LetterSpacing}`,
    boldHeader1: `${this.defaultFamily}${this.header1Size}${this.header1LineHeight}${this.semiBoldWeight}${this.header1LetterSpacing}`,
    header2: `${this.defaultFamily}${this.header2Size}${this.header2LineHeight}${this.mediumWeight}${this.header2LetterSpacing}`,
    boldHeader2: `${this.defaultFamily}${this.header2Size}${this.header2LineHeight}${this.semiBoldWeight}${this.header2LetterSpacing}`,
    header3: `${this.defaultFamily}${this.header3Size}${this.header3LineHeight}${this.mediumWeight}${this.header3LetterSpacing}`,
    boldHeader3: `${this.defaultFamily}${this.header3Size}${this.header3LineHeight}${this.semiBoldWeight}${this.header3LetterSpacing}`,
    header4: `${this.defaultFamily}${this.header4Size}${this.header4LineHeight}${this.mediumWeight}${this.header4LetterSpacing}`,
    boldHeader4: `${this.defaultFamily}${this.header4Size}${this.header4LineHeight}${this.semiBoldWeight}${this.header4LetterSpacing}`,
    header5: `${this.defaultFamily}${this.header5Size}${this.header5LineHeight}${this.mediumWeight}${this.header5LetterSpacing}`,
    boldHeader5: `${this.defaultFamily}${this.header5Size}${this.header5LineHeight}${this.semiBoldWeight}${this.header5LetterSpacing}`,

    button: `${this.defaultFamily}${this.normalButtonSize}${this.normalButtonLineHeight}${this.mediumWeight}`,
    boldButton: `${this.defaultFamily}${this.normalButtonSize}${this.normalButtonLineHeight}${this.semiBoldWeight}`,
    smallButton: `${this.defaultFamily}${this.smallButtonSize}${this.smallButtonLineHeight}${this.mediumWeight}`,
    boldSmallButton: `${this.defaultFamily}${this.smallButtonSize}${this.smallButtonLineHeight}${this.semiBoldWeight}`,

    body: `${this.defaultFamily}${this.bodySize}${this.bodyLineHeight}${this.normalWeight}`,
    boldBody: `${this.defaultFamily}${this.bodySize}${this.bodyLineHeight}${this.bold}`,
    small: `${this.defaultFamily}${this.smallSize}${this.smallLineHeight}${this.normalWeight}`,
    boldSmall: `${this.defaultFamily}${this.smallSize}${this.smallLineHeight}${this.bold}`,
    tiny: `${this.defaultFamily}${this.tinySize}${this.tinyLineHeight}${this.normalWeight}`,
    boldTiny: `${this.defaultFamily}${this.tinySize}${this.tinyLineHeight}${this.bold}`,

    eyebrow: `${this.defaultFamily}${this.eyebrowSize}${this.eyebrowLineHeight}${this.eyebrowLetterSpacing}${this.eyebrowTextTransform}${this.normalWeight}`,
    boldEyebrow: `${this.defaultFamily}${this.eyebrowSize}${this.eyebrowLineHeight}${this.eyebrowLetterSpacing}${this.eyebrowTextTransform}${this.bold}`,
  };
}
